import { Form, Select, Switch } from "antd";
import { ConfigurationEditorMiniComponent } from "components/common/configuration-editor-mini";
import { StyledSwitch } from "components/common/styled-swtich";
import { ChatBotSelector } from "components/pages/chat-bots/chat-bot-selector/chat-bot-selector";

export const ConnectionStartWithChatBotConfig = ({
  connectionId,
}: {
  connectionId: string;
}) => {
  return (
    <ConfigurationEditorMiniComponent
      entityType="CONNECTION"
      entityId={connectionId!}
      icon={"ri-robot-line"}
      title="Connect Chat Bot"
      description="Connect a Chat Bot when a conversation starts"
      miniEditor={
        <>
          <Form.Item
            valuePropName="checked"
            name={["data", "startWithChatBot", "isEnabled"]}
          >
            <Switch size="small" />
          </Form.Item>
        </>
      }
      triggerFullConfigOn={["data", "startWithChatBot", "isEnabled"]}
    >
      <StyledSwitch
        name={["data", "startWithChatBot", "isEnabled"]}
        label="Enabled"
      />
      <Form.Item shouldUpdate noStyle>
        {({ getFieldValue }) => {
          const configEnabled = getFieldValue([
            "data",
            "startWithChatBot",
            "isEnabled",
          ]);
          if (configEnabled) {
            return (
              <div>
                <Form.Item
                  name={["data", "startWithChatBot", "chatBotId"]}
                  label="Select Chatbot Flow"
                  rules={[
                    {
                      required: true,
                      message: "Please select a Chatbot flow",
                    },
                  ]}
                >
                  <ChatBotSelector />
                </Form.Item>
                <Form.Item
                  label="Activate Bot For"
                  name={["data", "startWithChatBot", "activateOn"]}
                  rules={[
                    {
                      required: true,
                      message: "Please select a an option",
                    },
                  ]}
                >
                  <Select placeholder="Select an option">
                    <Select.Option
                      key={"ALL_NEW_CONVERSATION"}
                      value={"ALL_NEW_CONVERSATION"}
                    >
                      New Chats and Re-Opened Chats
                    </Select.Option>
                    <Select.Option key={"NEW_LEAD"} value={"NEW_LEAD"}>
                      New Chats Only
                    </Select.Option>
                  </Select>
                </Form.Item>
              </div>
            );
          }
          return <></>;
        }}
      </Form.Item>
    </ConfigurationEditorMiniComponent>
  );
};
